// export { default as CourseList } from './CourseList';
export { default as Tabs } from './Tabs';
// export { default as CourseDetail } from './CourseDetail';
export { default as CourseCatalog } from './CourseCatalog';
export { default as CourseIntro } from './CourseIntro';
export { default as CourseComment } from './CourseComment';
export { default as CourseDownload } from './CourseDownload';
export { default as CoursePackList } from './CoursePackList';
// export { default as CoursePackDetail } from './CoursePackDetail';
export { default as CoursePackStages } from './CoursePackStages';
export { default as CoursePackIntro } from './CoursePackIntro';
export { default as CouseSelectList } from './CouseSelectList';
// export { default as CourseVideo } from './CourseVideo';
export { default as CourseAnswer } from './CourseAnswer';
// export { default as Coupon } from './Coupon';
export { default as CouponItem } from './CouponItem';



// WEBPACK FOOTER //
// ./src/features/course/index.js